import { CompactThemeToggle } from './ThemeToggle';

/**
 * Layout component for public pages (like form submissions) that don't require authentication
 * This layout excludes the main navigation bar but includes theme toggle
 */
interface PublicLayoutProps {
	children: React.ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
	return (
		<div className="min-h-screen bg-gray-50 dark:bg-gray-900">
			{/* Minimal header with just theme toggle */}
			<div className="absolute top-4 right-4 z-10">
				<CompactThemeToggle />
			</div>

			{/* Main content */}
			<main className="py-8">{children}</main>
		</div>
	);
}
